import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {AuthProvider} from "./context/authContext";
import {NextUIProvider} from "@nextui-org/react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <NextUIProvider>
        <AuthProvider>
            <App />
        </AuthProvider>
    </NextUIProvider>
);
